module.exports = __webpack_public_path__ + "images/common/user_register_recommendation_img_01_0bcf5a94c78948ae8ce7d0ed14f0a013.png";